// removed by extract-text-webpack-plugin
module.exports = {"LayoutContainer":"Main-LayoutContainer"};


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/theme/Main.less
// module id = 116
// module chunks = 0